import React, { useState } from 'react';
import axios from 'axios';
import { getAdminUser } from '../../../../Utils/Common';
import oceanapi, { updateTheme } from '../../../../Base/OceanConfig';
import { fileContentType, getPreSignedUrlPutObj } from '../../../../Utils/preSignedUrl';
import Message from '../../../../Components/Message/Message';
import style from '../../signup.module.css';

export default function UpdateTheme(props){
    const userId = getAdminUser();
    const subdomain = sessionStorage.getItem("subdomain");
    const userName = sessionStorage.getItem("userName");
    const [ primaryColor, setPrimaryColor ] = useState('#6091E2');
    const [ secondaryColor, setSecondaryColor ] = useState('#9462E7');
    const [ tertiaryColor, setTertiaryColor ] = useState('#00FFFB');
    const [ title, setTitle ] = useState(userName ? `${userName} - Home` : '');
    const [ description, setDescription ] = useState(userName ? `${userName} - API KYC Solution` : '');
    const [ logoFile, setLogoFile ] = useState('');
    const [ faviconFile, setFaviconFile ] = useState('');
    const [ progress, setProgress ] = useState(false);
    const [ loading, setLoading ] = useState(false);
    const [ message, setMessage ] = useState('');
    const [ messageClass, setMessageClass ] = useState('');

    const logoTheme = (e) => {
        e.preventDefault();
        setLoading(true);
        oceanapi.post(updateTheme, {
            userId : userId,
            subdomain : subdomain,
            title,
            description,
            logo: logoFile,
            favIcon: faviconFile,
            theme: {
                primaryColor: primaryColor,
                secondColor: secondaryColor,
                thirdColor : tertiaryColor
            }
        })
        .then((res) => {
            setLoading(false);
            if(res.data.code === 200){
                props.changeStep(5);
            } else {
                setMessageClass('error');
                setMessage(res.data.message);
                setTimeout(() => {
                    setMessage('')
                }, 5000);
            }
        })
        .catch((error) => {
            console.error(error);
            setLoading(false);
            setMessageClass('error');
            setMessage("Something went wrong, Try again!.");
            setTimeout(() => {
                setMessage('')
            }, 5000);
        })
    }

    const checkFileSize = (file, name) => {
        if(file){
            const fileName = file.name.replace(/ /g,"_");
            if(name === 'logo') {
                if(file.size/100000 > 10){
                    setMessageClass('error');
                    setMessage('File size is too large. Please select a file smaller than 1MB.');
                    setTimeout(() => {
                        setMessage('')
                    }, 5000);
                } else {
                    uploadFunction(file, fileName, name);
                }
            } else if(name === 'favicon') {
                if(file.size/10000 > 10){
                    setMessageClass('error');
                    setMessage('File size is too large. Please select a file smaller than 10KB.');
                    setTimeout(() => {
                        setMessage('')
                    }, 5000);
                } else {
                    uploadFunction(file, fileName, name);
                }
            }
        } else {
            setMessageClass('error');
            setMessage('Please select a file');
            setTimeout(() => {
                setMessage('')
            }, 5000);
        }
    }

    const uploadFunction = async (file, fileName, name) => {
        let x = Math.random().toString(36).slice(2, 7).toUpperCase();
        try {
            const fileName = x + file?.name
            const contentType = fileContentType(file?.name)
            const putObjUrl = await getPreSignedUrlPutObj(fileName, contentType, 'oceanService')
            if (putObjUrl === null) {
                throw new Error('some error while fething url')
            }
            setProgress(true);
            const res = await axios.put(putObjUrl, file, {
                headers: {
                    'Content-Type': contentType,
                },
            })
            if (res.status === 200) {
                setProgress(false);
                if(name === 'logo') {
                    setLogoFile(fileName);
                } else if(name === 'favicon') {
                    setFaviconFile(fileName);
                }
            }
        } catch (err) {
            console.log(err)
        }
    }
    
    return (<>
        {message && <Message message={message} messageClass={messageClass} closeMessage={() => setMessage('')} />}
        {progress && <div className='modal-container'>
            <div className='modal-background'></div>
            <div className='modal-box'>
                <div className={style['progress-modal']}>
                    <span className="fa fa-refresh fa-spin"></span>
                    <h4>Uploading, Please wait...</h4>
                </div>
            </div>
        </div>}
        <form onSubmit={logoTheme}>
            <h5 className={style['step-heading']}>Add Logo details</h5>
            <div className={style['upload-logo']}>
                <div>
                    <label>Upload Logo*<span>(Recommended logo size : Width=130-135px, Height=20-25px)</span></label>
                    <input type='file' accept=".png, .jpg, .jpeg" onChange={(e) => checkFileSize(e.target.files[0], 'logo')} required/>
                </div>
                <div>
                    <label>Upload Favicon*<span>(Recommended icon size : Width=15px, Height=15px)</span></label>
                    <input type='file' accept=".png, .jpg, .jpeg" onChange={(e) => checkFileSize(e.target.files[0], 'favicon')} required/>
                </div>
            </div>
            <br/>
            <h5 className={style['step-heading']}>Meta details</h5>
            <div className={style['meta-details']}>
                <div>
                    <label>Title*</label>
                    <input type='text' placeholder='Enter title' value={title} onChange={e => setTitle(e.target.value)} required/>
                </div>
                <div>
                    <label>Description*</label>
                    <input type='text' placeholder='Enter title' value={description} onChange={e => setDescription(e.target.value)} required/>
                </div>
            </div>
            <br/>
            <h5 className={style['step-heading']}>Add colour<span>(Add colour code in HEX format)</span></h5>
            <div>
                <div className={style['color-type']}>
                    <div className={style['primary']}>
                        <label>Primary color* :</label>
                        <input type='color' value={primaryColor} onChange={e => setPrimaryColor(e.target.value)}/>
                        <input type='text' placeholder='Enter primary colour' value={primaryColor} onChange={e => setPrimaryColor(e.target.value)} required/>
                    </div>
                    <div className={style['secondary']}>
                        <label>Secondary color* :</label>
                        <input type='color' value={secondaryColor} onChange={e => setSecondaryColor(e.target.value)}/>
                        <input type='text' placeholder='Enter secondary' value={secondaryColor} onChange={e => setSecondaryColor(e.target.value)} required/>
                    </div>
                    <div className={style['Tertiary']}>
                        <label>Tertiary color* :</label>
                        <input type='color' value={tertiaryColor} onChange={e => setTertiaryColor(e.target.value)}/>
                        <input type='text' placeholder='Enter tertiary' value={tertiaryColor} onChange={e => setTertiaryColor(e.target.value)} required/>
                    </div>
                </div>
            </div>
            <div className={style['upload-button']}>
                {
                    loading
                    ?<button className='btn primary-button' disabled>Wait...</button>
                    :<button type="submit" className='btn primary-button'>Next <img src="./images/arrow.svg" alt="arrow"/></button>
                }
            </div>
        </form>
    </>);
}